import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { UsersGroupsComponent } from "../../components/usersGroups"

export const UsersGroupsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <UsersGroupsComponent />
    </DefaultPageComp>
  </>
}